import Api from '@/services/api.js';

export default {
  getTippingDockets(payload) {
    return Api.post('tipping/get', payload)
  },

  matchDockets() {
    return Api.post('tipping/matchDockets')
  },

  addTrip(payload) {
    return Api.post(`tipping/addTrip/${payload.tippingDocketId}`, payload)
  },

  deleteMultipleTippingDockets(payload) {
    return Api.post('tipping/deleteMultiple', payload)
  },
  updateMultipleStatuses(payload) {
    return Api.post('tipping/updateMultipleStatuses', payload)
  },
  importTippingDockets(payload) {
    return Api.post('tipping/import', payload)
  },
  countMatchLines() {
    return Api.get('tipping/countMatchLines')
  },
  updateTippingDocketLine(payload) {
    return Api.put(`tipping/line/${payload.id}`, payload)
  },
  updateTippingDocketHeader(payload) {
    return Api.put(`tipping/header/${payload.id}`, payload)
  }
}